import { render, staticRenderFns } from "./newspaper-create.vue?vue&type=template&id=265da99c&"
import script from "./newspaper-create.vue?vue&type=script&lang=js&"
export * from "./newspaper-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports